import { Link } from 'react-router-dom';
import { useShowAuthenticatedLayout } from '@/hooks';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const showAuthenticatedLayout = useShowAuthenticatedLayout();

  return (
    <footer className="bg-gray-100 border-t mt-auto">
      <div
        className={`max-w-7xl mx-auto py-4 ${
          showAuthenticatedLayout
            ? 'pl-4 sm:pl-6 md:pl-20 pr-4 sm:pr-6 lg:pr-8'
            : 'px-4 sm:px-6 lg:px-8'
        }`}
      >
        <div className="flex flex-col sm:flex-row items-center justify-between text-sm text-gray-600">
          <div className="mb-2 sm:mb-0">
            &copy; {currentYear} Flouri, Inc. All rights reserved.
          </div>
          <nav className="flex items-center space-x-4">
            <Link
              to="/terms"
              className="hover:text-gray-900 transition-colors"
            >
              Terms & Conditions
            </Link>
            <span className="text-gray-300">|</span>
            <Link
              to="/privacy"
              className="hover:text-gray-900 transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-300">|</span>
            <a
              href="mailto:support@flouri.ai"
              className="hover:text-gray-900 transition-colors"
            >
              Contact
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
